import { Component, OnInit } from '@angular/core';
import { UiService } from 'src/app/shared/services/ui.service';

@Component({
  selector: 'app-error-server',
  templateUrl: './error-server.component.html',
  styleUrls: ['./error-server.component.scss']
})
export class ErrorServerComponent implements OnInit {

  constructor(
    public ui: UiService
  ) { }

  ngOnInit(): void {
  }

}
